module.exports = __webpack_public_path__ + "img/142.3.36410091.png";